export const SERVICE_FEATURES = {
  DAY: 'day_6_8',
  NIGHT: 'night_8_6',
  AWAY: 'away_monitored',
  HOME: 'home_monitored',
  OFF: 'off_monitored',
  QA_RECORDING: 'qa_recording',
};
